module.exports = __webpack_public_path__ + "static/media/cry2.ae5dc019.svg";